import { faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@restart/ui/esm/Button";
import { AvForm, AvInput } from "availity-reactstrap-validation";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Label } from "reactstrap";
import { clearErrorAndSuccessful, signInGuest } from "../redux/rootActions";
import { TranslationComponentProps } from "../types/translationComponentProps";

interface IProps extends TranslationComponentProps {
  closeGuestModal: () => void;
}

const GuestModal: React.FC<IProps> = (props: IProps) => {
  const [emptyNicknameError, setEmptyNicknameError] = useState(false);
  const dispatch = useDispatch();
  const { error } = useSelector((state: RootStateOrAny) => state.Auth);

  useEffect(() => {
    dispatch(clearErrorAndSuccessful());
  }, []);

  const handleValidSubmit = (event, values) => {
    setEmptyNicknameError(false);
    const nickname = values.nickname;
    if (nickname.trim() === "") {
      setEmptyNicknameError(true);
    }

    dispatch(signInGuest(nickname));
  };

  return (
    <div className="login">
      <AvForm onValidSubmit={handleValidSubmit}>
        <div className="d-flex justify-content-center pt-2 pl-3 w-100 login-header">
          <Label>{props.t("GUEST_MODAL.title")}</Label>
        </div>
        <div className="d-flex justify-content-center align-items-center font-weight-bold text-secondary pt-3 guest-modal-welcome">
          {props.t("GUEST_MODAL.welcome")}
        </div>
        <div className="d-flex justify-content-center text-secondary text-center guest-modal-description">
          {props.t("GUEST_MODAL.description")}
        </div>
        <div className="d-inline-flex w-100 align-items-center login-row">
          <Button className="login-input-btn" disabled>
            <FontAwesomeIcon icon={faUserAlt} />
          </Button>
          <AvInput
            className="login-input"
            name="nickname"
            placeholder={props.t("GUEST_MODAL.name")}
            type="text"
          />
        </div>
        <div className="d-inline-flex w-100 justify-content-center align-items-center login-submit mb-2 mt-2">
          <Button className="login-button" type="submit">
            {props.t("GUEST_MODAL.submit")}
          </Button>
        </div>
        {(error || emptyNicknameError) && (
          <div className="d-flex justify-content-center pt-1 mb-2 guest-modal-error">
            {props.t("GUEST_MODAL.error")}
          </div>
        )}
      </AvForm>
    </div>
  );
};

export default withTranslation()(GuestModal);
